import angular from "angular";
import { Lang } from "Roblox";

let recommendations = angular
    .module("recommendations", ["robloxApp", "thumbnails", "recommendationsAppTemplates"])
    .config(["languageResourceProvider", function (languageResourceProvider) {
        if (Lang.RecommendationsResources) {
            languageResourceProvider.setLanguageKeysFromFile(Lang.RecommendationsResources);
        }
    }]);

export default recommendations;